import React, { useEffect } from "react";
import { Typography } from "@material-ui/core";
import { ConsumerInfoForm } from "src/app/components/forms";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "src/lib/store";

export const ConsumerInfoPage: React.FC = () => {
  const history = useHistory();
  const payloadState = useSelector((state: RootState) => state.payload.data)

  useEffect(() => {
    if (payloadState.relationshipType === "") history.replace("/");
  }, [payloadState.relationshipType, history]);

  return (
    <>
      {payloadState.onBehalf === 'No' &&
        <Typography variant="h5" gutterBottom className="text-center mb-5">
          Let me gather some information about you.
        </Typography>}

      <ConsumerInfoForm />
    </>
  );
};
